interface SpotifyPlayerArgs {
    name: string;
}

export interface Spotify {
    player: any;
    authSpotifyUser: () => Promise<void>;
    checkForAccessToken: () => void;
    fetchDiscography: () => Promise<void>;
}

export interface authResponse {
    tokenData: tokenData;
    refreshToken: boolean;
    url?: string;
}
  
export interface tokenData {
    access_token: string;
    token_type: string;
    expires_in: number,
    refresh_token?: string;
    scope: string;
}

class SpotifyPlayer {
    name: string;
    player: any;

    constructor(args: SpotifyPlayerArgs) {
        this.name = args.name;
        this.init();
    }

    init(): { player: any, authSpotifyUser: () => Promise<void> } {
        window.onSpotifyWebPlaybackSDKReady = () => {
            const token = localStorage.getItem('spotify_access_token');
    
            if (token) {
              this.player = new (window as any).Spotify.Player({
                name: this.name,
                getOAuthToken: (cb: (token: string) => void) => { cb(token); },
                volume: 0.5
              });
            } else {
              console.log('No access token found');
            }
    
            this.spotifyListenerEvents();
            this.player.connect();
        }

        return this;
    }

    async authSpotifyUser(): Promise<void> {
        const response = await fetch('/.netlify/functions/spotify-auth');
        const data: authResponse = await response.json();
        this.handleSpotifyToken(data);
    }

    checkForAccessToken(): void {
        const token = this.getAccessTokenFromUrl();
        if (token) {
            this.storeAccessToken(token);
            const newUrl = window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
        }
    }

    handleSpotifyToken(data: authResponse): void {
        if (data.url) {
          window.location.href = data.url || '/';
        }else if (!data.refreshToken) {
          this.storeAccessToken(data.tokenData.access_token);
        } 
    }

    async fetchDiscography(): Promise<void> {
        const response = await fetch('/.netlify/functions/spotify-discog');
        const discography = await response.json();
        return discography;
    }

    private getAccessTokenFromUrl(): string | null {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('access_token');
        return token;
    }

    private storeAccessToken(token: string): void {
        localStorage.setItem('spotify_access_token', token);
    }

    spotifyListenerEvents(): void {
        this.player.addListener('ready', ({ device_id }: { device_id: string }) => {
          // 
        });
      
        this.player.addListener('not_ready', ({ device_id }: { device_id: string }) => {
          // 
        });
  
        this.player.addListener('initialization_error', ({ message }: { message: string }) => {
          // 
        });
    
        this.player.addListener('authentication_error', ({ message }: { message: string }) => {
          // 
        });
    
        this.player.addListener('account_error', ({ message }: { message: string }) => {
          // 
        });
    }
}

export default SpotifyPlayer;